import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FormProvider } from "./context/formsContext";
import { Forms } from "./Forms";
import { useInitialValues } from "./hooks";

type Props = {};

export default function FormsIndex(props: Props) {
	const navigate = useNavigate();
	const location = useLocation();
	const { AssetIdParam } = useParams();
	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	// A missing or non-numeric asset ("null" from a load before the user context) means no asset yet
	const hasValidAssetParam =
		!!AssetIdParam && Number.isInteger(Number(AssetIdParam));

	if (!hasValidAssetParam) {
		if (defaultAreaId === null || defaultAreaId === undefined) {
			return null;
		}
		navigate(
			{ pathname: `/forms/${defaultAreaId}`, search: location.search },
			{ replace: true },
		);
		return null;
	}

	// useSearchParamsToReducer is now called inside Filters component
	return (
		<>
			<HelmetDexteel title="Forms" />
			<FormProvider>
				<Forms />
			</FormProvider>
		</>
	);
}
